export enum OpEnum {
  DATA_POLICY_OP = 'data_policy_co',
  BYTTE_SDK_CONFIG = 'bytteSDKConfiguration',
  DSB_MOBILE_SDK_CONFIG = 'DSBMobileSDKConfigCO',
  ABRE_CUENTAS_CONFIGS = 'abre_cuentas_configs',
  ABRE_CUENTAS_BIOCATCH_CONFIGS = 'abrecuentas-co-biocatch-config',
  ABRE_CUENTAS_PRODUCTS = 'abre_cuentas_products',
  ABRE_CUENTAS_PRODUCTS_CE = 'abre_cuentas_products_ce',
  APROBADOS_FIRME_CE = 'aprobados_en_firme_ce',
  OCCUPATIONS_LIST = 'occupations_list',
  ABRE_CUENTAS_DETAIL_VTU = 'abre_cuentas_detail_vtu',
  SOURCE_OF_FUNDS = 'source_of_funds',
  CITY_LIST = 'city_list',
  ETHNIC_GROUP = 'ethnic_group',
  CIVIL_STATUS_LIST = 'civilStatus_list',
  CIIU_LIST = 'ciiu_list',
  CIIU_GENERAL_LIST = 'ciiu_general_list',
  FOREIGN_OPERATIONS_LIST = 'foreign_operations_list',
  AGENCY_LIST = 'agency_list',
  COUNTRY_LIST = 'country_list',
  DATA_TERMS_CONDITIONS = 'data_terms_conditions',
  TRANSACTION_KIT = 'transaction_kit',
  SAVING_TRANSACTION_KIT = 'saving_transaction_kit',
  CREDIT_TRANSACTION_KIT = 'credit_transaction_kit',
  GET_CASE_TIME_OUTS = 'abrecuentas-co-get-case-time-outs',
  BONDING_ASYNC = 'bonding-async',
  IMAGE_SET = 'image_set',
  OCUPATION_TIME_TC = 'occupation_time_tc',
  OCCUPATIONS_LIST_TC = 'occupations_list_tc',
  PAY_DATE_TC_LIST = 'pay_day_config_list',
  PRODUCTS_TC_LIST = 'products_tc_list',
  CONFIG_CLIENT_EXIST = 'client_exist_config',
  ALLIANCES_TC = 'alliances-tc',
  PHONE_MAIL_UPDATE_OP = 'phone_mail_update',
  REVOLVING_STEPS = 'revolving_steps',
  REVOLVING_STEPS_POST = 'revolving_steps_post',
  REVOLVING_STEPS_MULTI = 'revolving_steps_multi',
  REVOLVING_STEPS_MULTI_POST = 'revolving_steps_multi_post',
  DATA_DECLARATION_INSURABILITY = 'data_declaration_insurability',
  DATA_POLICY_ENDOSERD = 'data_policy_endoserd',
  HOUSING_TYPE = 'housingType_list',
  STRATUM = 'stratum-list',
  REVOLVING_CREDIT_CHARACTERISTICS = 'revolving_credit_characteristics_list',
  REVOLVING_CREDIT_CHARACTERISTICS_MULTI = 'revolving_credit_characteristics_list_multi',
  REVOLVING_BENEFITS = 'revolving-benefits',
  TAX_INFO_RATE = 'tax_info_rate',
  FREE_CREDIT_CHARACTERISTICS = 'free_credit_characteristics_list',
  LIVING_CHARACTERISTICS = 'living_characteristics_list',
  LIVING_SUCCESSFUL_LIST = 'living_successful_list',
  REVOLVING_CREDIT_SOPPORT_DOCUMENTS = 'revolving_credit_sopport_documents',
  FREE_CREDIT_SOPPORT_DOCUMENTS = 'free_credit_sopport_documents',
  INFO_TABLE = 'otp_problem_datasource',
  HOUSING_CHARACTERISTICS = 'housing_characteristics',
  BETA_PORTAL = 'beta_portal',
  LEGAL_REQUIREMENTS = 'legal_requirements',
  LEGAL_REQUIREMENTS_CHARACTERISTICS = 'legal_requirements_characteristics',
  LIVING_STEPS = 'living_steps',
  DOC_TYPE = 'document_type',
  GENDER_TYPE = 'gender_type',
  LIST_MULTI = 'products_card_and_credit',
  RESTRICTIVE_PARAMETERS = 'list_restrictive_parameter',
  ABRE_CUENTAS_BIOCATCH_CONFIGS_APPUNICA = 'abrecuentas-co-biocatch-config-appUnica',
  BIOCATCH_BODY_FIELDS_APP = 'biocatch-update-headers-appunica',
  BIOCATCH_BODY_FIELDS_PORTAL = 'biocatch-update-headers-portal',
  TIMER_WINDOWS_ORANGE = 'timer_windows_orange',
  OCCUPATION_LOAN = 'occupations_list_loan',
  REQUEST_ENTITY_NO = 'request-entity-no',
  REQUEST_ENTITY_SI = 'request-entity-si',
  LOAN_BANK_LIST = 'loan_bank_list',
  OUTLAY_OTHER_BANKS = 'other_banks_list',
  LIST_TYPE_CONTRACT_LOAN = 'listTypeContractLoan',
  PORTAL_OPERATOR_SUMMARY = 'portal_operator_summary',
  MULTIPLE_PRODUCT_TC_LIMITS = 'multiple_product_tc_limits',
  CREDIT_TYPE = 'credit_type_list',
  MAX_COUNT_PRODUCTS = 'max_count_products',
  MULTIP_OFFERT_C_ROTATIVO = 'multiple_product_editOfert_CRotativo_limits',
  TASASLIBRANZA = 'tasasLibranza',
  TASASLIBRANZAFRECUENCIA = 'tasasLibranzaFrecuencia',
  DOCUMENT_REQUIREMENTS = 'document_requirements',
  ATTACH_DOCUMENTS = 'attach_documents',
  TYPE_DOC_SERVICE = 'type_document_service',
  LOAN_BENEFITS_OFFER = 'loan_credit_characteristics_list',
  MOBILE_PHONE_PREFIXES = 'mobile_phone_prefixes',
  LIST_CREDITS = 'list_credits',
  COST_QUOTA_TC_FRANCHISE = 'cost_quota_tc_franchise',
  ADJUST_APPTOKEN = 'adjust_appToken',
  ALLIES_BIOCATCH_CONFIG = 'allies-biocatch-config',
  BIOCATCH_BODY_FIELDS_ALLIES = 'biocatch-update-headers-allies',
  URL_ALLIES = 'url_allies',
  REVOLVING_STEPS_ALLIES = 'revolving_steps_allies',
  ERROR_USER_NOT_IN_SECURITY_DB = 'error_user_not_in_security_db',
  NO_TRANSACTION_PRODUCTS = 'filter_no_transaction_products',
  GO_TO_ENROLLMENT = 'enrollment',
}
